/* Ivorlo Mouse Repellent Pouches: shared site script.
   Header, footer and cart drawer are injected here so every page stays identical.
   Variant IDs are filled in at deploy (deploy.js). */

const STORE = {
  name: "Ivorlo",
  email: "help@ivorlo.com",
  freeShipping: 45,
  protectionPrice: 2.99,
  shippingRate: 5.99 // flat rate under $45; keep in sync with Shopify shipping settings
};

/* Packs follow the market's unit (10 pouches a bag). Compare prices are the real
   cost of buying the same number of single bags, not invented "was" prices. */
const KITS = {
  one: {
    name: "Buy 1",
    sub: "1 bag | 10 pouches",
    bags: 1,
    pouches: 10,
    price: 34.99,
    compare: null,
    covers: "Best for small spaces",
    gifts: []
  },
  two: {
    name: "Buy 2",
    sub: "2 bags | 20 pouches",
    bags: 2,
    pouches: 20,
    price: 54.99,
    compare: 84.97, // 2 bags at $34.99 + $14.99 mesh roll
    covers: "Best for medium spaces",
    gifts: ["mesh"]
  },
  three: {
    name: "Buy 3",
    sub: "3 bags | 30 pouches",
    bags: 3,
    pouches: 30,
    price: 79.99,
    compare: 134.95, // 3 bags at $34.99 + $14.99 mesh roll + $14.99 gloves
    covers: "Best for large spaces",
    flag: "Most popular",
    gifts: ["mesh", "gloves"]
  }
};

// accepted payment marks (cart drawer + product page)
const PAY_BADGES = '<svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Visa"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#fff" stroke="#d9dcd4"/><text x="19" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="10.5" font-weight="900" font-style="italic" fill="#1a1f71" letter-spacing=".3">VISA</text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Mastercard"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#fff" stroke="#d9dcd4"/><circle cx="15.5" cy="12" r="6.5" fill="#eb001b"/><circle cx="22.5" cy="12" r="6.5" fill="#f79e1b"/><path d="M19 6.5a6.5 6.5 0 0 1 0 11 6.5 6.5 0 0 1 0-11z" fill="#ff5f00"/></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="American Express"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#2e77bc" stroke="#d9dcd4"/><text x="19" y="15.3" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="8.6" font-weight="900" fill="#fff" letter-spacing=".2">AMEX</text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Discover"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#fff" stroke="#d9dcd4"/><text x="3.5" y="14.6" textLength="13.6" lengthAdjust="spacingAndGlyphs" font-family="Arial,Helvetica,sans-serif" font-size="6" font-weight="800" fill="#231f20">DISC</text><circle cx="20.3" cy="12.5" r="2.7" fill="#f48120"/><text x="23.4" y="14.6" textLength="11" lengthAdjust="spacingAndGlyphs" font-family="Arial,Helvetica,sans-serif" font-size="6" font-weight="800" fill="#231f20">VER</text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Apple Pay"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#000" stroke="#d9dcd4"/><path fill="#fff" d="M12.6 8.4c.4-.5.7-1.2.6-1.9-.6 0-1.4.4-1.8.9-.4.4-.7 1.1-.6 1.8.7.1 1.4-.3 1.8-.8zm.6 1c-1-.1-1.8.6-2.3.6s-1.2-.5-2-.5c-1 0-2 .6-2.5 1.5-1.1 1.9-.3 4.6.8 6.1.5.7 1.1 1.5 1.9 1.5.7 0 1-.5 1.9-.5s1.1.5 1.9.5 1.3-.7 1.8-1.5c.5-.8.8-1.6.8-1.7 0 0-1.5-.6-1.5-2.4 0-1.5 1.2-2.2 1.3-2.3-.7-1-1.8-1.1-2.1-1.1z"/><text x="16.6" y="15.8" font-family="Arial,Helvetica,sans-serif" font-size="8.4" font-weight="600" fill="#fff">Pay</text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Google Pay"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#fff" stroke="#d9dcd4"/><text x="5" y="15.8" font-family="Arial,Helvetica,sans-serif" font-size="9" font-weight="700"><tspan fill="#4285f4">G</tspan><tspan fill="#5f6368" dx="1.5">Pay</tspan></text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="Shop Pay"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#5a31f4" stroke="#d9dcd4"/><text x="19" y="15.4" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="8" font-weight="800" font-style="italic" fill="#fff">shop<tspan font-weight="600"> Pay</tspan></text></svg><svg class="pay" viewBox="0 0 38 24" role="img" aria-label="PayPal"><rect x=".5" y=".5" width="37" height="23" rx="3.5" fill="#fff" stroke="#d9dcd4"/><text x="19" y="15.4" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="8.4" font-weight="900" font-style="italic"><tspan fill="#003087">Pay</tspan><tspan fill="#009cde">Pal</tspan></text></svg>';
const ICON_CHECK = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>', ICON_LOCK = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/><path d="M12 15v2"/></svg>', ICON_GIFT = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8.5h14V12M12 8v12.5"/><path d="M12 8C10.5 4.5 6.5 4 6.5 6.3 6.5 8 10 8 12 8zm0 0c1.5-3.5 5.5-4 5.5-1.7C17.5 8 14 8 12 8z"/></svg>';

// cart drawer thumbnails: images/cart-<id>.webp (one, two, three, mesh, gloves)
const cartImg = id => (window.IV_IMG || "./images/") + "cart-" + id + ".webp";

const GIFTS = {
  mesh: { name: "Copper Mesh Roll", value: 14.99, note: "Seal gaps around pipes and vents (step 1)" },
  gloves: { name: "PU Coated Work Gloves", value: 14.99, note: "For sealing gaps and clearing old nests" }
};

const ADDONS = {
  refill: { name: "Monthly Refill, 10 pouches", price: 23.99, sub: "Every 30 days, 20% off. Skip or cancel anytime.", recurring: true },
  traps: { name: "Snap Traps, 4 pack", price: 9.99, sub: "For mice that are already inside" },
  mesh: { name: "Copper Mesh Roll", price: 14.99, sub: "Seal the gaps they use to get in" }
};

// Shopify variant IDs (deploy.js fills these in; local preview shows a notice while null)
const SHOPIFY_VARIANTS = { one: 68352104988923, two: 68352105054459, three: 68352105021691, refill: null, traps: null, mesh: null, protection: 68302084112635, gift_mesh: 68353559101691, gift_gloves: 68353559134459 };
const SHOP_DOMAIN = "ivorlo.com";

/* ---------- ad-matched headlines (product.html?for=rv|car|home|boat|farm) ---------- */
const ANGLES = {
  default: {
    chip: "Made for the closed spaces mice move into each fall",
    h1: "Rodent Repellent Pouches",
    sub: "|Helps keep mice from nesting in your camper, car or pantry, so you can stop checking for droppings. No poison bait around kids and pets, just keep the pouches out of their reach.",
    photo: "02-sachet-in-a-camper-cabinet.webp",
    kit: "three"
  },
  rv: {
    chip: "For campers and RVs going into storage",
    h1: "Open your camper in spring and find it the way you left it.",
    sub: "A parked camper is exactly the quiet, closed space mice look for when it gets cold. A few pouches in the cabinets and bays, swapped every 30 days, give them a reason to skip yours.",
    photo: "05-sachet-in-a-camper-cabinet.webp",
    kit: "three"
  },
  car: {
    chip: "For cars and trucks that sit outside",
    h1: "Keep mice from turning your parked car into a nest.",
    sub: "Chewed wiring bills run $760 to $2,000 in the owner reviews and forums we read, and most warranties won't cover it. Two pouches in the cab and trunk, swapped monthly, cost a lot less.",
    photo: "04-sachet-in-pickup-truck.webp",
    kit: "one"
  },
  home: {
    chip: "For pantries, cabinets and garages",
    h1: "Your house isn't dirty. They're just cold.",
    sub: "Mice come inside every fall looking for warmth, clean house or not. Put pouches where they get in and where they'd nest, so your pantry and garage are the places they pass by.",
    photo: "10-sachet-in-a-warm-pantry.webp",
    kit: "three"
  },
  boat: {
    chip: "For boats in winter storage",
    h1: "Uncover your boat in spring without a nest in the cushions.",
    sub: "Under a cover or shrink wrap, a boat is still air for 5 months, which is where scent pouches last the longest. A few in the cabin and console and you're set for the season.",
    photo: "boat-locker-v2.webp",
    kit: "three"
  },
  farm: {
    chip: "For tractor cabs, shops and feed rooms",
    h1: "A season of pouches costs less than one chewed harness.",
    sub: "Pouches work in the closed spots: cabs, tool boxes, tack and feed rooms. They won't hold an open barn, and we'd rather tell you that now than refund you later.",
    photo: "11-sachet-in-a-tractor-cab.webp",
    kit: "three"
  }
};

/* ---------- calculator rates: pouches per space per month ---------- */
const SPACES = [
  { id: "car", label: "Car, truck or SUV", rate: 2 },
  { id: "camper", label: "Camper or travel trailer", rate: 4 },
  { id: "motorhome", label: "Motorhome or large RV", rate: 6 },
  { id: "boat", label: "Boat", rate: 3 },
  { id: "pantry", label: "Kitchen and pantry", rate: 3 },
  { id: "garage", label: "Garage cabinets and tool boxes", rate: 3 },
  { id: "basement", label: "Basement or attic (gaps sealed)", rate: 6 },
  { id: "cab", label: "Tractor or equipment cab", rate: 2 }
];

const money = n => "$" + n.toFixed(2);
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];

/* ---------- shared header / footer / drawer ---------- */
// "The Leaf O": two leaf halves forming the o of Ivorlo, nudged apart along the seam
const MARK = (left, right) => `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M31 5 C13 9 5 21 7 35 C9 47 19 56 31 57 C25 45 24 19 31 5 Z" fill="${left}" transform="translate(-0.5 1.5)"/><path d="M33 5 C51 9 59 21 57 35 C55 47 45 56 33 57 C39 45 40 19 33 5 Z" fill="${right}" transform="translate(0.5 -1.5)"/></svg>`;
const LOGO_SVG = MARK("#2f4a2c", "#5f9a2c");
const LOGO_SVG_WHITE = MARK("#ffffff", "#8fc45a");

function headerHTML(page) {
  const link = (href, label, key) => `<a href="${href}"${page === key ? ' class="active"' : ""}>${label}</a>`;
  return `
  <div class="announce">Fall Sale &middot; <strong>Save Over 40% + Free Gifts</strong></div>
  <header class="site-header">
    <div class="container header-inner">
      <a class="logo" href="/" aria-label="${STORE.name} home"><img class="logo-img" src="${(window.IV_IMG || "brand/") + "ivorlo-logo-sm.png"}" alt="${STORE.name}" width="272" height="96"></a>
      <nav class="main-nav" id="main-nav" aria-label="Main">
        ${link("/", "Home", "home")}
        ${link("/pages/rodent-repellent-pouches", "Shop Pouches", "product")}
        ${link("/pages/faqs", "FAQs", "faqs")}
        ${link("/pages/about-us", "About", "about")}
        ${link("/pages/contact-us", "Contact", "contact")}
      </nav>
      <div class="header-actions">
        <button class="cart-btn" data-open-cart aria-label="Open cart">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.2a1.5 1.5 0 0 0 1.5 1.2h8.7a1.5 1.5 0 0 0 1.5-1.1L21 7.5H6"/></svg>
          <span class="cart-count" id="cart-count">0</span>
        </button>
        <button class="menu-btn" id="menu-btn" aria-label="Open menu" aria-expanded="false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
        </button>
      </div>
    </div>
  </header>`;
}

function footerHTML() {
  return `
  <footer class="site-footer">
    <div class="container">
      <div class="footer-grid footer-grid-3">
        <div>
          <a class="footer-logo" href="/"><img class="logo-img-footer" src="${(window.IV_IMG || "brand/") + "ivorlo-logo-white-sm.png"}" alt="${STORE.name}" width="250" height="88"></a>
          <p class="footer-tag">Keep mice out of the things you store.<br>No poison bait, no traps, no mess.</p>
        </div>
        <div>
          <h4>Menu</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/pages/rodent-repellent-pouches">Mouse Repellent Pouches</a></li>
            <li><a href="/pages/faqs">FAQs</a></li>
            <li><a href="/pages/track-order">Track Order</a></li>
          </ul>
        </div>
        <div>
          <h4>Information</h4>
          <ul>
            <li><a href="/pages/contact-us">Contact Us</a></li>
            <li><a href="/pages/about-us">About Us</a></li>
            <li><a href="/pages/refund-policy#shipping">Shipping Policy</a></li>
            <li><a href="/pages/refund-policy">Return &amp; Refund Policy</a></li>
            <li><a href="/pages/terms-of-service">Terms of Service</a></li>
            <li><a href="/pages/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <span>&copy; ${new Date().getFullYear()} ${STORE.name}. All rights reserved.</span>
        <span><a href="mailto:${STORE.email}">${STORE.email}</a></span>
      </div>
    </div>
  </footer>
  <div class="overlay" id="overlay"></div>
  <aside class="drawer" id="drawer" aria-label="Cart" aria-hidden="true">
    <div class="drawer-head"><h3>Your Cart</h3><button class="drawer-close" data-close-cart aria-label="Close cart">&times;</button></div>
    <div class="ship-bar" id="ship-bar"><span id="ship-text"></span><div class="ship-track"><div class="ship-fill" id="ship-fill"></div></div></div>
    <div class="drawer-items" id="drawer-items"></div>
    <div class="drawer-foot">
      <label class="cart-protect"><svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 9.3 8 11 4.6-1.7 8-6 8-11V5l-8-3z" fill="#2f4a2c"/></svg><span class="cart-protect-text"><span class="cart-protect-title">Shipping Protection</span><span class="cart-protect-sub">Covers loss, damage &amp; theft in transit</span></span><span class="cart-protect-price">${money(STORE.protectionPrice)}</span><input type="checkbox" id="protect-toggle"><span class="cart-protect-switch"></span></label>
      <div class="cart-line"><span>Subtotal</span><span id="cart-subtotal">$0.00</span></div>
      <div class="cart-line"><span>Shipping</span><span id="cart-shipping">$0.00</span></div>
      <div class="cart-line" id="cart-protect-line"><span>Shipping Protection</span><span>${money(STORE.protectionPrice)}</span></div>
      <div class="cart-line cart-total"><span>Total</span><span id="drawer-total">$0.00</span></div>
      <button class="btn btn-primary btn-block cart-checkout-btn" id="checkout-btn">Checkout</button>
      <div class="checkout-msg" id="checkout-msg">Checkout isn't connected yet. This is a preview of the store. Real Shopify checkout gets wired in before launch.</div>
      <div class="cart-guarantee"><div class="cart-guarantee-title">30 Day Money Back Guarantee</div><div class="cart-guarantee-text">If mice still get in, email us within 30 days for a full refund. Keep the pouches.</div></div>
      <div class="cart-pay">${PAY_BADGES}</div>
    </div>
  </aside>`;
}

/* ---------- cart ---------- */
const CART_KEY = "ivorlo_cart_v2";
const PROTECT_KEY = "ivorlo_protect";
function readJSON(key, fallback) {
  try { const v = JSON.parse(localStorage.getItem(key)); return v === null ? fallback : v; } catch (e) { return fallback; }
}
function writeJSON(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* storage blocked, state lives for this page only */ }
}
let memoryCart = null;
let protect = readJSON(PROTECT_KEY, true); // pre-checked, as on ScratchZero
function cart() { return memoryCart || (memoryCart = readJSON(CART_KEY, [])); }
function saveCart(c) { writeJSON(CART_KEY, c); renderCart(c); }

function itemInfo(id) { return KITS[id] ? { ...KITS[id], kind: "kit" } : { ...ADDONS[id], kind: "addon" }; }

// Meta pixel: these are Shopify pages with a browser-side cart, so Shopify never sends AddToCart itself
function track(ev, data, n = 0) { if (window.fbq) fbq("track", ev, data); else if (window.IV_LIVE && n < 20) setTimeout(() => track(ev, data, n + 1), 500); }

function addToCart(id, qty = 1) {
  const k = itemInfo(id);
  track("AddToCart", { content_type: "product", content_ids: [String(SHOPIFY_VARIANTS[id] || id)], content_name: "Mouse Repellent Pouches: " + k.name, value: k.price * qty, currency: "USD" });
  const c = cart();
  const line = c.find(i => i.id === id);
  if (line) line.qty += qty; else c.push({ id, qty });
  saveCart(c);
  openCart();
}
function changeQty(index, delta) {
  const c = cart();
  c[index].qty += delta;
  if (c[index].qty <= 0) c.splice(index, 1);
  saveCart(c);
}
function removeLine(index) { const c = cart(); c.splice(index, 1); saveCart(c); }

function cartGifts(c) {
  const g = new Set();
  c.forEach(i => (KITS[i.id] ? KITS[i.id].gifts : []).forEach(x => g.add(x)));
  return [...g];
}

function renderCart(c = cart()) {
  const count = c.reduce((s, i) => s + i.qty, 0);
  const badge = $("#cart-count");
  if (badge) { badge.textContent = count; badge.classList.toggle("show", count > 0); }
  const list = $("#drawer-items");
  if (!list) return;
  const merch = c.reduce((s, i) => s + itemInfo(i.id).price * i.qty, 0);
  const gifts = cartGifts(c);
  if (!c.length) {
    list.innerHTML = `<div class="drawer-empty"><p>Your cart is empty.</p><a class="btn btn-ghost" href="/pages/rodent-repellent-pouches">Choose your pouches</a></div>`;
  } else {
    const lines = c.map((i, idx) => {
      const k = itemInfo(i.id);
      const pic = k.kind === "kit" ? i.id : i.id === "mesh" ? "mesh" : null;
      const thumb = pic ? `<img src="${cartImg(pic)}" alt="">` : "+";
      const sub = k.kind === "kit" ? k.sub : k.sub;
      return `<div class="d-item">
        <div class="d-thumb">${thumb}</div>
        <div>
          <div class="d-name">${k.kind === "kit" ? "Mouse Repellent Pouches, " + k.name : k.name}</div>
          <div class="d-sub">${sub}${k.recurring ? "" : ""}</div>
          <div class="d-qty"><button data-dec="${idx}" aria-label="Decrease">&minus;</button><span>${i.qty}</span><button data-inc="${idx}" aria-label="Increase">+</button></div>
        </div>
        <div><div class="d-price">${money(k.price * i.qty)}${k.recurring ? "<small>/mo</small>" : ""}</div>${k.compare ? `<div class="d-was">${money(k.bags * KITS.one.price * i.qty)}</div>` : ""}<button class="d-remove" data-remove="${idx}">Remove</button></div>
      </div>`;
    }).join("");
    const giftLines = gifts.map(g => `<div class="d-item d-gift">
        <div class="d-thumb gift"><img src="${cartImg(g)}" alt=""></div>
        <div><div class="d-name">${GIFTS[g].name}</div><div class="d-sub">Bonus gift with your kit</div></div>
        <div><div class="d-price">$0.00</div><div class="d-was">${money(GIFTS[g].value)}</div></div>
      </div>`).join("");
    // on the live store, only offer add-ons that exist as real Shopify products
    const offers = Object.keys(ADDONS).filter(a => !c.some(i => i.id === a) && !(a === "mesh" && gifts.includes("mesh")) && (!window.IV_LIVE || SHOPIFY_VARIANTS[a]));
    const upsell = offers.length ? `<div class="upsells"><div class="upsells-title">Pairs well with your pouches</div>${offers.map(a => `
        <div class="upsell"><div><div class="d-name">${ADDONS[a].name}</div><div class="d-sub">${ADDONS[a].sub}</div></div>
        <button class="btn btn-ghost btn-sm" data-addon="${a}">Add ${money(ADDONS[a].price)}${ADDONS[a].recurring ? "/mo" : ""}</button></div>`).join("")}</div>` : "";
    list.innerHTML = lines + giftLines + upsell;
  }
  const shipping = !c.length || merch >= STORE.freeShipping ? 0 : STORE.shippingRate;
  const prot = c.length && protect ? STORE.protectionPrice : 0;
  const total = merch + shipping + prot;
  $("#protect-toggle").checked = protect;
  $(".cart-protect").style.display = c.length ? "" : "none";
  $("#cart-protect-line").style.display = prot ? "" : "none";
  $("#cart-subtotal").textContent = money(merch);
  $("#cart-shipping").textContent = !c.length ? "$0.00" : shipping ? money(shipping) : "FREE";
  $("#drawer-total").textContent = money(total);
  const left = STORE.freeShipping - merch;
  $("#ship-text").innerHTML = merch === 0 ? `Free shipping on orders over $${STORE.freeShipping}`
    : left > 0 ? `You're <strong>${money(left)}</strong> away from free shipping` : `<strong>You've unlocked free shipping.</strong>`;
  $("#ship-fill").style.width = Math.min(100, (merch / STORE.freeShipping) * 100) + "%";
}

function openCart() {
  $("#drawer").classList.add("show"); $("#overlay").classList.add("show");
  $("#drawer").setAttribute("aria-hidden", "false");
}
function closeCart() {
  $("#drawer").classList.remove("show"); $("#overlay").classList.remove("show");
  $("#drawer").setAttribute("aria-hidden", "true");
  $("#checkout-msg").classList.remove("show");
}

function checkout() {
  const c = cart();
  if (!c.length) return;
  const ids = c.map(i => i.id).concat(protect ? ["protection"] : []);
  if (ids.some(id => !SHOPIFY_VARIANTS[id])) { $("#checkout-msg").classList.add("show"); return; }
  const giftIds = cartGifts(c).map(g => SHOPIFY_VARIANTS["gift_" + g]).filter(Boolean);
  const items = c.map(i => `${SHOPIFY_VARIANTS[i.id]}:${i.qty}`).concat(giftIds.map(v => `${v}:1`), protect ? [`${SHOPIFY_VARIANTS.protection}:1`] : []).join(",");
  const btn = $("#checkout-btn"); btn.disabled = true; btn.textContent = "Redirecting...";
  window.location.href = `${window.IV_LIVE ? "" : "https://" + SHOP_DOMAIN}/cart/${items}`;
}

/* ---------- buy box (product page) ---------- */
let selectedKit = "three";

function renderTiers(container) {
  container.innerHTML = Object.entries(KITS).map(([id, k]) => {
    const save = k.compare ? Math.round((1 - k.price / k.compare) * 100) : 0;
    return `
    <label class="tier" data-tier="${id}">
      <input type="radio" name="kit" value="${id}">
      ${k.flag ? `<span class="flag">${k.flag}</span>` : ""}
      <span class="dot"></span>
      <span class="t-main"><span class="t-name">${k.name}</span><span class="t-covers">${k.sub}<span class="t-per"><span class="t-dot"> &middot; </span>${money(k.price / k.pouches)} a pouch</span></span><span class="t-covers t-fit">${k.covers}</span></span>
      <span class="t-price"><span class="p">${money(k.price)}</span>${k.compare ? `<span class="was">${money(k.compare)}</span><span class="save">Save ${save}%</span>` : ""}</span>
    </label>`;
  }).join("");
  $$(".tier", container).forEach(t => t.addEventListener("click", () => selectKit(t.dataset.tier)));
}

function renderGiftBar() {
  const box = $("#gift-unlock");
  if (!box) return;
  const have = KITS[selectedKit].gifts;
  box.innerHTML = `<div class="gift-title">Free bonus gifts with your pouches</div><div class="gift-grid">${Object.entries(GIFTS).map(([id, g]) => {
    const on = have.includes(id);
    const unlockAt = Object.values(KITS).find(k => k.gifts.includes(id));
    return `<div class="gift ${on ? "on" : ""}"><div class="gift-ic">${on ? ICON_CHECK : ICON_LOCK}</div><div><strong>${g.name}</strong><span>${on ? `FREE <s>${money(g.value)}</s>` : `Unlocks with ${unlockAt.name}`}</span></div></div>`;
  }).join("")}${shipTile()}</div>`;
}

// free shipping tile: unlocks on any kit at or over the free shipping threshold
function shipTile() {
  const on = KITS[selectedKit].price >= STORE.freeShipping;
  const unlockAt = Object.values(KITS).find(k => k.price >= STORE.freeShipping);
  return `<div class="gift ${on ? "on" : ""}"><div class="gift-ic">${on ? ICON_CHECK : ICON_LOCK}</div><div><strong>Free Tracked Shipping</strong><span>${on ? "Included" : `Unlocks with ${unlockAt.name}`}</span></div></div>`;
}

function selectKit(id) {
  selectedKit = id;
  $$("#tiers .tier").forEach(t => {
    const on = t.dataset.tier === id;
    t.classList.toggle("selected", on);
    $("input", t).checked = on;
  });
  const k = KITS[id];
  $$("[data-atc-label]").forEach(el => el.textContent = `Add To Cart · ${money(k.price)}`);
  $$("[data-sticky-name]").forEach(el => el.textContent = `${k.name} · ${k.pouches} pouches`);
  $$("[data-sticky-price]").forEach(el => el.textContent = money(k.price));
  renderGiftBar();
}

function applyAngle() {
  const hero = $("[data-angle-hero]");
  if (!hero) return;
  const key = new URLSearchParams(location.search).get("for");
  const a = ANGLES[key] || ANGLES.default;
  $$("[data-angle]").forEach(el => {
    const val = a[el.dataset.angle];
    if (!val) return;
    if (el.dataset.angle === "sub") {
      // first sentence becomes the lead line, the rest sits under it
      // lead line ends at "|" if present, otherwise at the first sentence
      const bar = val.indexOf("|");
      if (bar > -1) {
        el.innerHTML = "";
        if (val.slice(0, bar).trim()) { const l = document.createElement("span"); l.className = "sub-lead"; l.textContent = val.slice(0, bar).trim(); el.appendChild(l); }
        const r = document.createElement("span"); r.className = "sub-rest"; r.textContent = val.slice(bar + 1).trim(); el.appendChild(r);
        return;
      }
      const cut = val.indexOf(". ");
      const lead = cut > -1 ? val.slice(0, cut + 1) : val;
      const rest = cut > -1 ? val.slice(cut + 2) : "";
      el.innerHTML = "";
      const l = document.createElement("span"); l.className = "sub-lead"; l.textContent = lead; el.appendChild(l);
      if (rest) { const r = document.createElement("span"); r.className = "sub-rest"; r.textContent = rest; el.appendChild(r); }
    } else if (el.tagName === "IMG") {
      const base = (window.IV_IMG || "./images/") + val.replace(".webp", "");
      if (el.closest(".g-thumb")) el.src = base + "-160.webp";
      else if (el.dataset.src !== undefined) { el.dataset.src = base + "-800.webp"; el.dataset.srcset = ["480", "640", "800"].map(w => `${base}-${w}.webp ${w}w`).join(", "); }
      else { el.removeAttribute("srcset"); el.src = base + "-800.webp"; }
    } else {
      el.textContent = val;
    }
  });
  selectKit(a.kit);
  if (key && ANGLES[key]) document.body.dataset.angle = key;
}

/* ---------- gallery ---------- */
function wireGallery(root) {
  const track = $(".g-track", root), slides = $$(".g-slide", root), thumbs = $$(".g-thumb", root);
  // slides 2+ load after the page is done (or on the first swipe/tap), so they don't compete with slide 1
  let loaded = false;
  const loadRest = () => {
    if (loaded) return; loaded = true;
    $$("img[data-src]", root).forEach(img => { if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.src = img.dataset.src; img.removeAttribute("data-src"); img.removeAttribute("data-srcset"); });
  };
  if (document.readyState === "complete") setTimeout(loadRest, 1200); else window.addEventListener("load", () => setTimeout(loadRest, 1200));
  ["pointerdown", "touchstart", "focusin"].forEach(ev => root.addEventListener(ev, loadRest, { once: true, passive: true }));
  const go = i => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" }); };
  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  thumbs.forEach((t, i) => t.addEventListener("click", () => go(i)));
  $(".g-prev", root).addEventListener("click", () => go(current() - 1));
  $(".g-next", root).addEventListener("click", () => go(current() + 1));
  track.addEventListener("scroll", () => {
    loadRest();
    const i = current();
    thumbs.forEach((t, j) => t.classList.toggle("on", i === j));
    const n = $(".g-count", root); if (n) n.textContent = `${i + 1} / ${slides.length}`;
  }, { passive: true });
}

/* ---------- tabs ---------- */
function wireTabs(root) {
  const btns = $$("[data-tab]", root), panes = $$("[data-pane]", root);
  btns.forEach(b => b.addEventListener("click", () => {
    btns.forEach(x => x.classList.toggle("on", x === b));
    panes.forEach(p => p.hidden = p.dataset.pane !== b.dataset.tab);
  }));
}

/* ---------- calculator ---------- */
const calcState = {};
function bestKits(n) {
  let best = null;
  for (let a = 0; a <= Math.ceil(n / KITS.three.pouches) + 1; a++)
    for (let b = 0; b <= 3; b++)
      for (let c = 0; c <= 3; c++) {
        const pouches = a * KITS.three.pouches + b * KITS.two.pouches + c * KITS.one.pouches;
        if (pouches < n) continue;
        const cost = a * KITS.three.price + b * KITS.two.price + c * KITS.one.price;
        if (!best || cost < best.cost - 0.001 || (Math.abs(cost - best.cost) < 0.001 && pouches < best.pouches))
          best = { three: a, two: b, one: c, pouches, cost };
      }
  return best;
}

function renderCalc(root) {
  const rows = $(".calc-rows", root);
  rows.innerHTML = SPACES.map(s => {
    calcState[s.id] = calcState[s.id] || 0;
    return `<div class="calc-row">
      <div><div class="c-label">${s.label}</div><div class="c-rate">${s.rate} pouches a month each</div></div>
      <div class="stepper"><button data-c-dec="${s.id}" aria-label="Fewer">&minus;</button><span id="c-${s.id}">${calcState[s.id]}</span><button data-c-inc="${s.id}" aria-label="More">+</button></div>
    </div>`;
  }).join("");
  rows.addEventListener("click", e => {
    const inc = e.target.closest("[data-c-inc]"), dec = e.target.closest("[data-c-dec]");
    if (inc) calcState[inc.dataset.cInc] = Math.min(9, calcState[inc.dataset.cInc] + 1);
    if (dec) calcState[dec.dataset.cDec] = Math.max(0, calcState[dec.dataset.cDec] - 1);
    if (inc || dec) updateCalc(root);
  });
  $("#calc-months", root).addEventListener("change", () => updateCalc(root));
  updateCalc(root);
}

function updateCalc(root) {
  SPACES.forEach(s => { const el = $("#c-" + s.id, root); if (el) el.textContent = calcState[s.id]; });
  const months = +$("#calc-months", root).value;
  const perMonth = SPACES.reduce((s, sp) => s + sp.rate * calcState[sp.id], 0);
  const need = perMonth * months;
  const out = $(".calc-result", root);
  if (!need) {
    out.innerHTML = `<p class="muted">Add the spaces you want to protect and we'll work out how many pouches you need, and the cheapest way to get them.</p>`;
    return;
  }
  const b = bestKits(need);
  const parts = [];
  if (b.three) parts.push(`${b.three} &times; Buy 3`);
  if (b.two) parts.push(`${b.two} &times; Buy 2`);
  if (b.one) parts.push(`${b.one} &times; single bag`);
  out.innerHTML = `
    <div class="big">You need about ${need} pouches</div>
    <p>${perMonth} a month for ${months} month${months > 1 ? "s" : ""}. Cheapest way to get there: <strong>${parts.join(" + ")}</strong> (${b.pouches} pouches, ${money(b.cost)}).</p>
    <button class="btn btn-primary" id="calc-add">Add to cart</button>`;
  $("#calc-add", out).addEventListener("click", () => {
    const c = cart();
    [["three", b.three], ["two", b.two], ["one", b.one]].forEach(([id, q]) => {
      if (!q) return;
      const line = c.find(i => i.id === id);
      if (line) line.qty += q; else c.push({ id, qty: q });
    });
    saveCart(c); openCart();
  });
}

/* ---------- forms without a backend yet ---------- */
function wireForms() {
  // Shopify redirects back with ?contact_posted=true after the contact form sends
  if (/[?&]contact_posted=true/.test(location.search)) {
    const sent = $("#contact-sent"); if (sent) sent.classList.add("show");
    const f = $("[data-contact-form]"); if (f) f.style.display = "none";
  }
}

/* ---------- boot ---------- */
document.addEventListener("DOMContentLoaded", () => {
  $$("[data-pay]").forEach(el => { el.innerHTML = PAY_BADGES; });
  const page = document.body.dataset.page || "";
  const h = $("#site-header"); if (h) h.outerHTML = headerHTML(page);
  const f = $("#site-footer"); if (f) f.outerHTML = footerHTML();

  document.addEventListener("click", e => {
    if (e.target.closest("[data-open-cart]")) openCart();
    if (e.target.closest("[data-close-cart]") || e.target.id === "overlay") closeCart();
    const q = e.target.closest("[data-quick-add]");
    if (q) addToCart(q.dataset.quickAdd);
    const ad = e.target.closest("[data-addon]");
    if (ad) addToCart(ad.dataset.addon);
    const inc = e.target.closest("[data-inc]"), dec = e.target.closest("[data-dec]"), rm = e.target.closest("[data-remove]");
    if (inc) changeQty(+inc.dataset.inc, 1);
    if (dec) changeQty(+dec.dataset.dec, -1);
    if (rm) removeLine(+rm.dataset.remove);
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });
  $("#checkout-btn").addEventListener("click", checkout);
  $("#protect-toggle").addEventListener("change", e => { protect = e.target.checked; writeJSON(PROTECT_KEY, protect); renderCart(); });

  const menuBtn = $("#menu-btn");
  menuBtn.addEventListener("click", () => {
    const open = $("#main-nav").classList.toggle("open");
    menuBtn.setAttribute("aria-expanded", open);
  });

  const tiers = $("#tiers");
  if (tiers) {
    track("ViewContent", { content_type: "product", content_ids: [String(SHOPIFY_VARIANTS.three || "three")], content_name: "Mouse Repellent Pouches", value: KITS.three.price, currency: "USD" });
    if (window.IV_LIVE && !SHOPIFY_VARIANTS.refill) { const r = $(".refill-row"); if (r) r.style.display = "none"; }
    renderTiers(tiers);
    selectKit(selectedKit);
    applyAngle();
    $$("[data-atc]").forEach(btn => btn.addEventListener("click", () => {
      addToCart(selectedKit, 1);
      const r = $("#refill"); if (r && r.checked && !cart().some(i => i.id === "refill")) addToCart("refill", 1);
    }));
    const sticky = $("#sticky-atc"), buy = $("#buy-box");
    if (sticky && buy && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0))
        .observe(buy);
    }
  }

  $$("[data-gallery]").forEach(wireGallery);
  $$("[data-tabs]").forEach(wireTabs);
  const calc = $("#calc"); if (calc) renderCalc(calc);
  wireForms();
  renderCart();
});
